// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__K7Xi7","spinner":"Loading_spinner__Y9jaO","spin":"Loading_spin__grgdF"};